var getPositionFormEvents = function (e) {
  if (e.offsetX && e.offsetY) {
    return {
      x: e.offsetX,
      y: e.offsetY
    }
  }
  var touch = e.originalEvent.touches[0];

  if (touch && touch.clientX && touch.clientY) {
    var bb = e.target.getBoundingClientRect();

    return {
      x: touch.clientX - bb.x,
      y: touch.clientY - bb.y
    }
  }
  throw new Error('Cant get position from move event!')
};

var DrawingController = function ($canvas, $clearBtn) {
  this.$canvas = $canvas;
  this.context = $canvas[0].getContext("2d");
  this.isDrawing = false;
  this.$clearBtn  = $clearBtn;
  this.$field = $('[name=' + this.$canvas.data('field') + ']');

  var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning

  (function () {
    $('#save').click(function (e) {
      console.log('click on btn');
      if (self.isCanvasBlank()) {
        alert('Canvas is blank!')
      } else {
        self.saveImage();
      }
    });

    self.$clearBtn.click(function (e) {
      self.clear();
    });

  }());
};

DrawingController.prototype.drawing = function () {

  var self = this;

  //On mouse events on the canvas
  self.$canvas.on('touchstart mousedown', function (e) {
    self.lastPos = getPositionFormEvents(e);
    self.isDrawing = true;
  }).on('touchmove mousemove', function (e) {
    if (self.isDrawing) {
      var pos = getPositionFormEvents(e);

      self.context.beginPath();
      self.context.moveTo(self.lastPos.x, self.lastPos.y);
      self.context.lineTo(pos.x, pos.y);

      self.context.stroke();

      self.lastPos = pos;
        e.stopPropagation();
        return false;
    }
  }).on('touchend mouseup', function () {
    self.isDrawing = false;
  }).on('mouseleave', function () {
    self.$canvas.mouseup();
  });
}

DrawingController.prototype.isCanvasBlank = function () {

  var blank = document.createElement('canvas');
  blank.width = this.$canvas[0].width;
  blank.height = this.$canvas[0].height;

  return this.$canvas[0].toDataURL() == blank.toDataURL();
};

DrawingController.prototype.clear = function () {
  this.context.clearRect(0, 0, this.$canvas[0].width, this.$canvas[0].height);
};

DrawingController.prototype.saveImage = function () {

  var self = this;
  var base64 = self.$canvas[0].toDataURL('image/png');

  var w = window.open('about:blank', 'image from canvas');
  w.document.write("<img src='" + base64 + "' alt='from canvas'/>");
};

DrawingController.prototype.saveInInput = function () {

	var self = this;
	var base64 = self.$canvas[0].toDataURL('image/png');

	// console.log(self.$canvas.data('field'));
	// console.log(base64);
	// console.log(self.$field);

	self.$field.val(base64);
};

module.exports = DrawingController;